import {
  HttpClient,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UserService } from '@modules/shared/services/user.service';

@Injectable()
export class ExpiredTokenInterceptor implements HttpInterceptor {
  httpClient = inject(HttpClient);
  injector = inject(Injector);

  /*
   * HTTP Interceptor
   * Catches an API error, when the current session token is expired and needs to be refreshed OR remeoved by the login app
   */
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401 && error.error.error === 'Expired, malformed or invalid token.') {
          const userService = this.injector.get(UserService);
          userService.logout();
        }
        throw error;
      })
    );
  }
}
